<template>
  <div>
    <div class="hader">
      <p>
        <span>{{ Number(anIndex) + 1 }}</span>
        <span>[{{ TestItems.Style }}]</span>
        <span v-html="TestItems.Title"></span>
      </p>
    </div>
    <div class="main">
      <el-radio-group
        v-model="TestItems.UserAnswer"
        fill="##A90505"
        v-if="!practice"
      >
        <el-radio
          :label="item.ItemName"
          v-for="(item, index) in TestItems.SelectedItems"
          :key="index"
          @change="saveAnswer(item)"
        >
          <p>
            {{ item.ItemName + "." }}
            <span v-html="item.Content"> </span>
          </p>

          <!-- {{ item.ItemName + "." + item.Content }} -->
        </el-radio>
      </el-radio-group>
      <div v-else class="practice_view">
        <ul>
          <li v-for="(item, index) in TestItems.SelectedItems" :key="index" @click="saveAnswer(item.ItemName)">
             <img src="@/assets/student/choice.png" alt="" v-if="practiceColour(item) === 'green'">
             <img src="@/assets/student/errorx.png" alt="" v-else-if="practiceColour(item) === 'red'">
             <div class="default" v-else></div>
            <p :class="practiceColour(item)">
              {{ item.ItemName + "." }}
              <span v-html="item.Content"> </span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["TestItems", "anIndex", "userAbswerArr", "practice"],
  methods: {
    // 保存答案
    saveAnswer(item) {
      if (this.practice) {
        // 练习状态进来
        this.TestItems.UserAnswer = item
      }
      const AbswerObj = {
        TestID: this.TestItems.TestID,
        ChildTableID: this.TestItems.TestID,
        UserAnswer: this.TestItems.UserAnswer,
        Score: this.TestItems.Score,
        IsRight:
          this.TestItems.UserAnswer == this.TestItems.Answer ? true : false,
      };
      this.$emit("userAbswer", AbswerObj);
      // console.log(item, this.TestItems);
     
      console.log(AbswerObj);
    },
    // 回显用户刷新保存上次答案
    theEchoAbswer() {
      this.userAbswerArr.forEach((item) => {
        if (item.TestID == this.TestItems.TestID) {
          this.TestItems.UserAnswer = item.UserAnswer;
        }
      });
    },
  },
  computed: {
    practiceColour() {
      return function (item) {
        if (this.TestItems.UserAnswer && this.practice) {
          // 练习才触发
          if (
            this.TestItems.UserAnswer == this.TestItems.Answer &&
            item.ItemName == this.TestItems.UserAnswer
          ) {
            // 答案正确且相同
            return "green";
          }
          if (
            this.TestItems.UserAnswer != this.TestItems.Answer
            // &&
            // item.ItemName == this.TestItems.UserAnswer
          ) {
            // 答案错误且相同
            // console.log(this.TestItems.Answer,item.ItemName);
            if (this.TestItems.Answer == item.ItemName) {
              return "green";
            } else if (item.ItemName == this.TestItems.UserAnswer) {
              return "red";
            } else {
              return "";
            }
          } else {
            return "";
          }
        } else {
          return "";
        }
      };
    },
  },
  created() {
    if(!this.practice){
      this.theEchoAbswer();
    }
  },
};
</script>

<style lang="scss" scoped>
.hader {
  min-height: 68px;
  display: flex;
  // align-items: center;
  background: #f7f7f7;
  user-select: none;
  padding: 12px 24px;
  p {
    text-align: left;
    span {
      &:nth-child(1) {
        color: #119ce5;
        font-weight: bold;
        font-size: 150%;
        margin: 0px 14px 18px 0px;
      }
      &:nth-child(2) {
        color: #119ce5;
        font-weight: bold;
      }
    }
  }
}
.main {
  padding: 36px 30px;
  user-select: none;
  ::v-deep .el-radio-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    .el-radio__label {
      font-size: 18px;
    }
    .el-radio {
      display: flex;
      margin-bottom: 18px;
    }
  }
}
.green {
  color: rgb(1, 207, 151);
}
.red {
  color: #ee4f3b;
}
.practice_view {
  > ul {
    list-style-type: none;
    > li {
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-bottom: 12px;
      cursor: pointer;
      >img{
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      .default{
        border:2px solid #d1dde4;
        width: 24px;
        height: 24px;
        border-radius:50%;
        margin-right:10px;
        // margin-top:12px;
      }
    }
  }
}
</style>
<style>
input[aria-hidden="true"] {
  display: none !important;
}
</style>